import React, { useState } from 'react';
import { Button } from '@mui/material';

export function TagButton({
    title = '',
    text,
    id = '',
    color = "primary",
    endIcon = null,
    hoverIcon = null, // Nuevo prop para el icono al hacer hover
    href = "",
    onClick = () => { },
    sx = {},
    startIcon = null,
}) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Button
            color={color}
            id={id}
            href={href}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)} // Maneja el evento hover
            onMouseLeave={() => setIsHovered(false)} // Resetea el evento hover
            sx={{
                borderRadius: "30px",
                color: "#ffffff",
                px: ".5rem",
                py: "2px",
                textTransform: "none",
                ...sx,
            }}
            variant="contained"
            startIcon={startIcon}
            endIcon={isHovered && hoverIcon ? hoverIcon : endIcon} // Cambia el ícono dinámicamente
            title={title}
        >
            {text}
        </Button>
    );
}

export function TagHashButton({
    title = '',
    text,
    color = "primary",
    endIcon = null,
    hoverIcon = null, // Nuevo prop para el icono al hacer hover
    href = "",
    sx = {},
    startIcon = null,
}) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Button
            href={href}
            onMouseEnter={() => setIsHovered(true)} // Maneja el evento hover
            onMouseLeave={() => setIsHovered(false)} // Resetea el evento hover
            sx={{
                borderRadius: "4px",
                borderLeft: "4px solid #666B6E",
                backgroundColor: "#F0F0F1",
                color: "#666B6E",
                px: ".5rem",
                py: "2px",
                textTransform: "none",
                fontSize: "0.8rem",
                ...sx,
            }}
            variant={color}
            startIcon={startIcon}
            endIcon={isHovered && hoverIcon ? hoverIcon : endIcon} // Cambia el ícono dinámicamente
            title={title}
        >
            {text}
        </Button>
    );
}

export default TagButton;
